<template>
  <div class="house">
    <div class="rightmouse"
         :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>回收站</el-breadcrumb-item>
          <el-breadcrumb-item>视频回收站</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main"
         v-loading="isRefresh">
      <div class="head disflex">
        <div class="left">
          <h4 style="font-size:18px;margin-left:5px;">视频回收站<span style="font-size:13px;font-weight:300;">（{{nnclutteredPic || 0}}个）</span></h4>
        </div>

        <div class="rightpic disflex">
          <span>删除时间：</span>
          <el-date-picker v-model="delTime"
                              type="daterange"
                              align="center"
                              @change="dateChange"
                              value-format="timestamp"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"></el-date-picker>
          <el-button :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" v-if="choosePic.length > 0 && powersObj.recoveryCommand" @click.stop="allRecovery">
            恢复
          </el-button>
          <el-button :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" v-if="choosePic.length > 0 && powersObj.deleteCommand" @click.stop="allDel">
            彻底删除
          </el-button>
          <!-- <p @click="picSortFlag = true"
             :class="picSortFlag === true ? isSimple ? 'simpleactive' : 'active' : ''">按天排序</p>
          <div>|</div>
          <p @click="picSortFlag = false"
             :class="picSortFlag === true ? '' : isSimple ? 'simpleactive' : 'active'">按月排序</p> -->
        </div>
      </div>

      <div v-loading="isDelete"
           class="piclist"
           style="display:flex;">
        <div style="width:100%;min-height:805px;">
          <!-- <div v-if="choosePic.length > 0"
               @click.stop="plDelete"
               class="del">
            <div style="text-align:center;">
              <img src="@/assets/personpic/alldel.png"
                   alt="">
              <p style="margin-left:3px;">删除</p>
            </div>
          </div> -->
          <template v-if="picSortFlag"> 
            <div class="time"
                 v-for="(e,i) in testList"
                 :key="i">
              <el-checkbox @change="choosePicChange(testList[i].time420,e.picList,i)"
                           :indeterminate="testList[i].indeterminate"
                           v-model="testList[i].time420">{{e.mycreateAt}}</el-checkbox>
              <div class="yuan"></div>
              <div class="xian"></div>

              <div class="datepic">
                <section>

                  <div :class="choosePic.indexOf(item.id) === -1 ? 'img-wrapper':isSimple ? 'img-wrapper simpleimgborder' : 'img-wrapper imgborder'"
                       @click="choosePicClick(item.id,i,item.atlasId)"
                       v-for="(item, index) in e.picList"
                       :key="index">
                    <video style="height:120px;"
                            :src="item.src"></video>
                    <!-- <el-image class="img"
                         @contextmenu.prevent="rightShow($event)"
                         ondragstart="return false;"
                         :src="item.src" >
                         <div slot="error"
                          class="image-slot">
                          <img src="@/assets/house/onloadpicerror.png"
                              alt />
                        </div>
                    </el-image> -->

                    <div class="dian">
                      <img src="@/assets/piclist/dian.png" alt="">
                      <div class="diannr">

                        <p @click.stop="seePic(item,index,i)">查看视频</p>
                        <p v-if="powersObj.recoveryCommand" @click.stop="recoveryPic(item)">恢复视频</p>
                        <p v-if="powersObj.deleteCommand" @click.stop="delPic(item)">彻底删除</p>
                      </div>
                    </div>

                    <div class="play">
                      <img src="@/assets/piclist/playb.png"
                          width="40px"
                          alt />
                    </div>

                    <!-- 修改图片信息 -->
                    <!-- <el-tooltip class="item"
                                effect="dark"
                                content="修改图片说明"
                                placement="top">
                      <div @click.stop="openChangeDesc(item)"
                           class="changedesc">
                        <img src="@/assets/sreenpic/desc.png"
                             alt="">
                      </div>
                    </el-tooltip> -->

                    <!-- 修改图片信息 -->
                    <!-- <el-tooltip class="item"
                                effect="dark"
                                content="查看图片"
                                placement="top">
                      <div @click.stop="seePic(item,index,i)"
                           class="seepic">
                        <img src="@/assets/solicitationactivities/see.png"
                             alt="">
                      </div>
                    </el-tooltip> -->

                    <div v-if="choosePic.indexOf(item.id) !== -1"
                         class="delete">
                      <img :src="isSimple ? require('@/assets/personpic/simplegou.png') : require('@/assets/personpic/gou.png')"
                           alt="">
                    </div>
                  </div>

                </section>
              </div>
            </div>

          </template>

          <template v-if="!picSortFlag">
            <div class="time"
                 v-for="(e,i) in testListMonth"
                 :key="i">
              <el-checkbox @change="choosePicChange(testList[i].time420,e.picList,i)"
                           :indeterminate="testList[i].indeterminate"
                           v-model="testList[i].time420">{{e.mycreateAtMonth}}</el-checkbox>
              <div class="yuan"></div>
              <div class="xian"
                   style="left:99px;"></div>

              <div class="datepic">
                <section>

                  <div :class="choosePic.indexOf(item.id) === -1 ? 'img-wrapper':isSimple ? 'img-wrapper simpleimgborder' : 'img-wrapper imgborder'"
                       @click="choosePicClick(item.id,i,item.atlasId)"
                       v-for="(item, index) in e.picList"
                       :key="index">
                    <img class="img"
                         @contextmenu.prevent="rightShow($event)"
                         ondragstart="return false;"
                         :src="item.src" />
                    <div v-if="choosePic.indexOf(item.id) !== -1"
                         class="delete">
                      <img :src="isSimple ? require('@/assets/personpic/simplegou.png') : require('@/assets/personpic/gou.png')"
                           alt="">
                    </div>
                  </div>

                </section>
              </div>
            </div>
          </template>

          <template v-if="testList.length === 0">
            <div class="nopic">
              <img src="@/assets/piclist/nonr.png"
                   alt />
            </div>
          </template>
          <img v-if="showLoading"
               width="200px"
               style="margin-left:40%"
               src="@/assets/blue-preloader.gif"
               alt />
        </div>
      </div>

    </div>

    <!-- 查看未整理图片 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="90%"
      top="12vh"
      :before-close="handleClose"
      :show-close="false"
    >
      <!-- 关闭按钮 -->
      <div @click="handleClose" class="close">
        <img
          :style="{ 'margin-top': displayResolution < 1600 ? '-2px' : '0px' }"
          src="@/assets/picbrowse/close.png"
          alt
        />
      </div>
      <div class="left">
        <div
          class="pic"
          v-loading="imgLoading"
          element-loading-text="正在加载视频中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <div class="imgBj" ref="imgBj">
            <!-- <div
              ref="imgPic"
              @contextmenu.prevent="rightShow($event)"
              ondragstart="return false;"
              @click="seeBigSmall"
              :style="{ height: '98%', width: '100%', backgroundImage: 'url(' + choosePicMsg.picThumbW1080 + ')', backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }"
            ></div> -->
            <video-player class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          style="width:70%;height:100%;"
                          :playsinline="true"
                          :options="playerOptions"></video-player>
            <div @click.stop="bigLeft" class="leftjt">
              <div class="message" v-show="showMessageLeft">这是第一个哟~</div>
            </div>
            <div @click.stop="bigRight" class="rightjt">
              <div class="message" v-show="showMessageRight">这是最后一个哟~</div>
            </div>
            <i
              @click="picRotateRight"
              v-if="seeFull"
              class="el-icon-refresh-right"
              style="  position:absolute; bottom:20px; left:45%; font-size: 30px;"
            ></i>
            <i
              @click="picRotateLeft"
              v-if="seeFull"
              class="el-icon-refresh-left"
              style="position:absolute; bottom:20px;font-size: 30px;"
            ></i>
          </div>

          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn">
          <i @click.stop="picRotateRight"
             class="el-icon-refresh-right"></i>
          <i @click.stop="picLarge"
             class="el-icon-zoom-in"></i>
          <i @click.stop="picSmall"
             class="el-icon-zoom-out"></i>
          <i @click.stop="picRotateLeft"
             class="el-icon-refresh-left"></i>
          </div>-->
        </div>

        <div class="picinf disflex">
          <!-- <p class="picinfleft">
          {{atlasInfo.name}} / 共
          <span>{{atlasInfo.pictureCount}}</span>张
          </p>-->
          <div class="picinfright disflex">
            <!-- <div
            @click.stop="lovePic"
            class="disflex spare"
            :style="{background: !haslovechange ?'url('+ require('@/assets/picbrowse/spare.png') +') no-repeat':'url('+ require('@/assets/picbrowse/sparelove.png') +') no-repeat'}"
          >
            <div class="icon"></div>
            <p>选用</p>
          </div>
          <div @click="setIndexPic" class="disflex book">
            <div class="icon"></div>
            <p>设为封面</p>
          </div>
          <div @click="deletePic" class="disflex delete">
            <div class="icon"></div>
            <p>移除</p>
            </div>-->
            <!-- <div @click.stop="dev" class="disflex download">
              <div class="icon"></div>
              <p>下载原图 <span style="font-size:12px;"> (已下载{{choosePicMsg.downloadCount}}次)</span> </p>
            </div>-->
          </div>
        </div>

        <div ref="piclist" class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1" @click="smallLeft" class="leftjt">
            <i style="font-size:30px;" class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist" style="display:flex;transition:1s;">
            <div @click="picListClick(e, i)" v-for="(e,i) in picList" :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div
                :style="{ backgroundImage: 'url(' + e.picThumbWh160 + ')', cursor: 'pointer' }"
                @contextmenu.prevent="rightShow($event)"
                ondragstart="return false;"
                :class="picAllListFlag === i || choosePicMsg.myId === i ? 'picimg active' : 'picimg'"
              ></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13" @click="smallRight" class="rightjt">
            <i style="font-size:30px;" class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="title">
          <p>视频信息</p>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>：
          <span>{{ choosePicMsg.fileCreateAt || '无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">删除时间</div>：
          <span>{{ choosePicMsg.createAtMy || '无' }}</span>
        </div>
        <!-- <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">所属资源库</div>：
          <span>{{ choosePicMsg.libName || '无' }}</span>
        </div> -->
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">视频大小</div>：
          <span>{{ choosePicMsg.fileSize }}MB</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">视频格式</div>：
          <span>{{ choosePicMsg.format }}</span>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.desc">
          <p>视频说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{ choosePicMsg.desc }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { searchAtlas } from '@/api/search'
import { deletePicture,recyclePicture,listRecyclePicture } from '@/api/picture'
import { deleteVideo,recycleVideo,listRecycleVideo } from '@/api/video'
import { formatConversion } from '@/plugins/getdate'
import { listLib } from "@/api/lib";
import { getFileInfoById } from "@/api/file"
import { picPrefix } from "@/constants/piccommon";
import { addAtlas, updateAtlas } from "@/api/atlas";
import { listPeopleFaceByPeopleId } from "@/api/peopleFace";
import { listPeople, setPass, markPeople, getPeopleConstant, mergePeople } from "@/api/people";
import { powersObj, allowLib } from "@/constants/powers";
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";

export default {
  inject: ['reload'],
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      //筛选
      delTime:[],
      timeStart:'',
      timeEnd:'',

      //可见性权限
      statusFlag: false,

      //图集信息
      atlasInfo: null,

      //根据分辨率判断长度
      documentHeight: 0,
      minRows: 8,
      maxRows: 12,


      //权限
      powersObj,
      allowLib,


      //批量操作
      plFlag: true,



      //分辨率
      row: 1,
      widthWithUP: '',
      displayResolution: 0,

      //图集间距
      atlasMargin: '',

      //侧边栏是否收起
      isAside: this.bus.val,

      picPrefix,


      //选中的图片
      choosePic: [],
      chooseAtlasId: [],


      //当日所有的图片
      testList: [],
      //当月所有的图片
      testListMonth: [],

      //存储所有未整理图片
      allPicList: [],

      atlasId: '',
      libId: '',
      isSave: false,

      //是按天还是按月排序   
      picSortFlag: true,
      picinfClass: "picinf",

      //时间排序 
      sortFlag: true,

      //未整理图片的个数
      nnclutteredPic: "",

      currentPage: 0,

      //显示我的资源集还是未整理图片   0为图集
      isPic: 0,

      //分页
      total: 0,
      pageSize: 40,
      page: 0,
      totalPic: 0,
      pageSizePic: 10,
      pagePic: 0,
      orderByTime: 0,

      //所有图集
      picList: [],

      faceMarginTop: '',

      isRefresh: false,

      
      isReLoad: false,
      isDelete: false,
      alreadyPicLength: 0,

      //查看图片相关
      atlasName: '新建资源集',

      //图片说明
      descdialogVisible: false,
      message: '',

      //查看未整理图片相关
      dialogVisible: false,
      passChoose: {},
      inPicList: [],
      showLoading: false,
      passFlag: true,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,




      seeFull: false,
      choosePicMsg: { labels: [] },
      displayResolution: 0,
      picAllListFlag: -1,
      scroll: 0,
      picCha: -1,
      haslovechange: false,
      imgLoading: false,//图片加载
      picTimes: 1,
      picDeg: 0,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,

      showMessageLeft: false,
      showMessageRight: false,

      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
    };
  },
  methods: {

    //时间筛选
    dateChange(){
      if (this.delTime) {
        this.delTime[0] = this.delTime[0];
        this.delTime[1] = this.delTime[1] + 86399000;
        if (this.delTime[0]) {
          this.timeStart = this.delTime[0] / 1000;
          this.timeEnd = this.delTime[1] / 1000;
        }
      } else {
        this.timeStart = "";
        this.timeEnd = "";
      }
      this.isRefresh = true
      this.currentPage = 0
      this.choosePic = []
      this.nnclutteredPic = 0
      this.testList = []
      this.testListMonth = []
      this.listUnclutteredPictureAsync({
            page: this.currentPage,
            pageSize:this.pageSize,
            timeEnd:this.timeEnd,
            timeStart:this.timeStart
          })

    },

    //批量恢复图片
    allRecovery(){
      this.$confirm("确认恢复这些视频吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          // console.log(e);
          this.isDelete = true
          let atlasIds = [...new Set(this.chooseAtlasId)] 
          console.log(this.chooseAtlasId);
          this.recyclePictureOneAsync({
            atlasIds:atlasIds.join(','),
            ids:this.choosePic.join(',')
          })
        })
    },

    //批量删除图片
    allDel(){
      this.$confirm("确认彻底删除这些视频吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          // console.log(e);
          this.isDelete = true
          for (let i = 0; i < this.choosePic.length; i++) {
            this.deletePictureAsync(this.choosePic[i],i)
          }

          
        })
    },

    //单个恢复图片
    recoveryPic(e){
      this.$confirm("确认恢复该视频吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          // console.log(e);
          this.isDelete = true
          this.recyclePictureOneAsync({
            atlasIds:e.atlasId,
            ids:e.id
          })
        })
    },
    //单个删除图片
    delPic(e){
      this.$confirm("确认删除该视频吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.isDelete = true
          this.deletePictureOneAsync(e.id)
        })
    },

    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },




    //查看未整理图片
    seePic (e, ci, i) {
      e.createAtMy = e.mycreateAt
      if (e.fileInfo.savepath) {
        e.format = e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3)
      } else {
        e.format = '暂无'
      }
      this.choosePicMsg = e
      this.choosePicMsg.myId = ci
      this.getPicInfo(this.choosePicMsg)
      this.playerOptions.sources[0].src = this.choosePicMsg.src
      this.picList = this.testList[i].picList
      for (let z = 0; z < this.picList.length; z++) {
        this.picList[z].myId = z
      }
      this.dialogVisible = true
    },
    handleClosepic () {
      this.dialogVisible = false
    },


    //查看图集信息
    seeAtlas (e) {
      this.atlasName = '图集信息'
      this.ruleForm = {
        name: e.name,
        region: e.libId || 0,
        desc: e.desc,
        status: e.status,
        id: e.id,
        indexpicId: e.indexpicId,
        sourceType: e.sourceType,
      }
      this.dialogVisiblePutIn = true
      // console.log(e)
    },

    

    changeUploadMode () {
      if (this.uploadMode === 0) {

        this.uploadMode = 1
      } else {
        this.uploadMode = 0
      }
    },



   


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.currentPage = 0
      this.choosePic = []
      this.delTime = []
      this.timeEnd = ''
      this.timeStart = ''

      //获取未整理图片
      this.listUnclutteredPictureAsync({
            page: this.currentPage,
            pageSize:this.pageSize,
            timeEnd:this.timeEnd,
            timeStart:this.timeStart
          })


      this.displayResolution = document.documentElement.clientWidth;

      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },





    //选择图片
    choosePicClick (id, i,aid) {
      if (this.choosePic.indexOf(id) === -1) {
        this.choosePic.push(id)
        this.chooseAtlasId.push(aid)
        this.testList[i].indeterminate = true
        this.testList[i].chooseFlag++
        if (this.testList[i].chooseFlag === this.testList[i].picList.length) {
          this.testList[i].time420 = true
          this.testList[i].indeterminate = false
        }
      } else {
        this.choosePic.splice(this.choosePic.indexOf(id), 1)
        this.chooseAtlasId.splice(this.chooseAtlasId.indexOf(aid), 1)
        this.testList[i].chooseFlag--

        if (this.testList[i].chooseFlag === 0) {
          this.testList[i].indeterminate = false
          this.testList[i].time420 = false
        } else {
          this.testList[i].indeterminate = true
          this.testList[i].time420 = false
        }
      }
    },

    //选择改变的图片
    choosePicChange (check, pl, index) {
      this.testList[index].indeterminate = false
      if (check) {
        pl.forEach((e, i) => {
          if (this.choosePic.indexOf(e.id) === -1) {
            this.choosePic.push(e.id)
            this.chooseAtlasId.push(e.atlasId)
            this.testList[index].chooseFlag++
          }
        })
      } else {
        pl.forEach((e, i) => {
          if (this.choosePic.indexOf(e.id) !== -1) {
            this.choosePic.splice(this.choosePic.indexOf(e.id), 1)
            this.chooseAtlasId.splice(this.chooseAtlasId.indexOf(e.atlasId), 1)
            this.testList[index].chooseFlag--
          }
        })
      }
    },



    

    //批量删除
    plDelete () {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.isSave = true
          this.isDelete = true
          for (let i = 0; i < this.choosePic.length; i++) {
            this.deletePictureAsync(this.choosePic[i])
          }

          setTimeout(() => {
            this.allPicList = []
            this.testList = []
            this.testListMonth = []
            this.choosePic = []
            this.nnclutteredPic = 0
            this.listUnclutteredPictureAsync({
              page: this.currentPage,
              pageSize:this.pageSize,
              timeEnd:this.timeEnd,
              timeStart:this.timeStart
            })
            this.isSave = false
            this.isDelete = false
          }, 1000);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },


    //滚动加载图库和图片
    scrollPic () {
      // let isBottom = (document.documentElement.scrollTop + window.innerHeight) === document.body.offsetHeight

      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;

      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      // this.pic.id = scrollTop
      if (isBottom) {
        // if (this.isPic === 0) {

        // } else if (this.isPic === 1) {
        let allLength = 0
        for (let i = 0; i < this.testList.length; i++) {
          allLength += this.testList[i].picList.length
        }
        if (allLength < this.nnclutteredPic && this.passFlag) {
          this.currentPage++;
          let params = {
            page: this.currentPage,
            pageSize:this.pageSize,
            timeEnd:this.timeEnd,
            timeStart:this.timeStart
          };
          this.showLoading = true
          setTimeout(() => {
            this.listUnclutteredPictureAsync(params);
          }, 1000);
        }
        // } else if (this.isPic == 2) {

        // }


      }
    },


    //把接口返回的json转换成数组---按日期
    dealWithData (data) {
      let c = [];
      let d = {};
      data.forEach(element => {
        if (!d[element.mycreateAt]) {
          c.push({
            time420: false,
            indeterminate: false,
            chooseFlag: 0,
            mycreateAt: element.mycreateAt,
            picList: [element]
          });
          d[element.mycreateAt] = element;
        } else {
          c.forEach(ele => {
            if (ele.mycreateAt == element.mycreateAt) {
              ele.picList.push(element);
            }
          });
        }

      });
      return c;
    },

    //把接口返回的json转换成数组---按月份
    dealWithMonth (data) {
      let c = [];
      let d = {};
      data.forEach(element => {
        if (!d[element.mycreateAtMonth]) {
          c.push({
            time420: false,
            indeterminate: false,
            chooseFlag: 0,
            mycreateAtMonth: element.mycreateAtMonth,
            picList: [element]
          });
          d[element.mycreateAtMonth] = element;
        } else {
          c.forEach(ele => {
            if (ele.mycreateAtMonth == element.mycreateAtMonth) {
              ele.picList.push(element);
            }
          });
        }

      });
      return c;
    },


    unclutter () {

      if (this.isPic !== 1) {
        this.nnclutteredPic = 0
        this.testList = []
        this.testListMonth = []
        this.currentPage = 0
        this.listUnclutteredPictureAsync({
            page: this.currentPage,
            pageSize:this.pageSize,
            timeEnd:this.timeEnd,
            timeStart:this.timeStart
          })
      }

      setTimeout(() => {
        this.isPic = 1
      }, 200);
    },

    async deletePictureOneAsync (val) {
      let {status, data, message} = await deleteVideo(val)
      if(status){
        this.$message.success('删除成功！')
        this.isDelete = false
        this.refresh()
      }else{
        this.$message.error('删除失败！')
        this.isDelete = false
      }
    },
    async recyclePictureOneAsync (val) {
      let {status, data, message} = await recycleVideo(val)
      if(status){
        this.$message.success('视频恢复成功！')
        this.isDelete = false
        this.refresh()
      }else{
        this.$message.error('视频恢复失败！')
        this.isDelete = false
      }
    },

    async deletePictureAsync (val,i) {
      await deleteVideo(val)
      if(i == this.choosePic.length - 1){
        this.isDelete = false
        this.$message.success('删除成功！')
        this.refresh()
      }
    },




    //获取未整理图片
    async listUnclutteredPictureAsync (val) {
      let { status, data, message, pagination, errors } = await listRecycleVideo(val);
      this.isRefresh = false
      if (status) {

        this.nnclutteredPic = pagination.total
        for (let i = 0; i < data.length; i++) {
          if (data[i].createAt !== 0) {
            data[i].mycreateAt = formatConversion(data[i].updateAt.toString()).substring(0, 10)
          } else {
            data[i].mycreateAt = '暂无创建时间'
          }
          if (data[i].createAt !== 0) {
            data[i].mycreateAtMonth = formatConversion(data[i].updateAt.toString()).substring(0, 7)
          } else {
            data[i].mycreateAtMonth = '暂无创建时间'
          }
          if (data[i].fileInfo) {
            data[i].fileCreateAt = formatConversion(data[i].fileInfo.createAt.toString()).substring(0, 10)
            if(data[i].fileInfo.encodeSavepath){
              data[i].src = picPrefix + data[i].fileInfo.encodeSavepath
            }else{
              data[i].src = picPrefix + data[i].fileInfo.savepath
            }
          } else {
            data[i].src = require('@/assets/house/onloadpic.png')
          }

          if(data[i].exif){
            
            if(data[i].exif.exif){
              let exif = JSON.parse(data[i].exif.exif)
              if(exif.hasOwnProperty('video_cover')){
                data[i].picThumbWh160 = picPrefix + exif.video_cover
              }else{
                data[i].exif.videoCaptureFileIds = data[i].exif.videoCaptureFileIds.split(',')
                let picInfo = await getFileInfoById(data[i].exif.videoCaptureFileIds[0])
                if (picInfo.data) {
                  if (picInfo.data.picThumbWh160) {
                    data[i].picThumbWh160 = picPrefix + picInfo.data.picThumbWh160
                  } else {
                    data[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
                  }
                } else {
                  data[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
                }
              }
            }
          } else {
            data[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
          }
        }
        // this.testList = this.dealWithData(data)
        // this.testListMonth = this.dealWithMonth(data)


        if (this.currentPage === 0) {
          this.testList = this.dealWithData(data)
          this.testListMonth = this.dealWithMonth(data)
          this.allPicList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.allPicList.push(data[i])
          }
          this.testList = this.dealWithData(this.allPicList)
          this.testListMonth = this.dealWithMonth(this.allPicList)


          // let date = this.dealWithData(data)
          // for (let i = 0; i < date.length; i++) {
          //   this.testList.push(date[i]);
          // }
          // let month = this.dealWithMonth(data)
          // for (let i = 0; i < month.length; i++) {
          //   this.testListMonth.push(month[i]);
          // }
        }
        console.log(this.testList);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
      this.showLoading = false
      this.passFlag = true
    },




    //判断分辨率
    judgRes () {
      if (this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "16px"
      } else if (this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "38px"
      } else if (!this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "45px"
      } else if (!this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "75px"
      }
    },

    //判断gril的row值
    checkRow () {
      this.displayResolution = document.documentElement.clientWidth;
      if (this.displayResolution > 2800) {
        this.row = 9
        this.widthWithUP = "13%"
        this.faceRow = 8
        this.widthWithUPFace = '23.5%'
      } else
        if (this.displayResolution > 2700) {
          this.row = 8
          this.widthWithUP = "13%"
          this.faceRow = 7
          this.widthWithUPFace = '23.5%'
        } else
          if (this.displayResolution > 2500) {
            this.row = 7
            this.widthWithUP = "13%"
            this.faceRow = 6
            this.widthWithUPFace = '23.5%'
          } else
            if (this.displayResolution > 2400) {
              this.row = 6
              this.widthWithUP = "14%"
              this.faceRow = 5
              this.widthWithUPFace = '23.5%'
            } else
              if (this.displayResolution > 2000) {
                this.row = 5
                this.widthWithUP = "16%"
                this.faceRow = 4
                this.widthWithUPFace = '23.5%'
              } else

                if (this.displayResolution > 1700) {
                  this.row = 5
                  this.widthWithUP = "18%"
                  this.faceRow = 4
                  this.widthWithUPFace = '23.5%'
                }
      if (this.displayResolution <= 1700) {
        this.row = 4
        this.widthWithUP = "21.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1600) {
        this.row = 4
        this.widthWithUP = "22.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1550) {
        this.row = 3
        this.widthWithUP = "22.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1400) {
        this.row = 3
        this.widthWithUP = "25%"
        this.faceRow = 2
        this.widthWithUPFace = '25%'
      }
    },







    handleClose() {
      this.dialogVisible = false
    },
    seeBigSmall() {
      this.switechValue = false
      console.log(1);
      this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      if (this.seeFull) {
        fullScreen(this.$refs.imgBj)
        this.$refs.imgPic.style.cursor = 'zoom-out'
      } else {
        exitFullscreen()
        this.$refs.imgPic.style.cursor = 'zoom-in'
        // this.picTimes = 1
        // this.picDeg = 0
        // this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      }
    },
    //图片放大
    picLarge() {
      this.picTimes += 1.5;
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform =
          "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      } else {
        this.picTimes = 6;
        this.$refs.imgPic.style.transform =
          "scale(6) rotateZ(" + this.picDeg + "deg)";
      }
    },
    //图片缩小
    picSmall() {
      this.picTimes -= 1.5;
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform =
          "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      } else {
        this.picTimes = 1;
        this.$refs.imgPic.style.transform =
          "scale(1) rotateZ(" + this.picDeg + "deg)";
      }
    },

    //图片旋转
    picRotateLeft() {
      this.picDeg -= 90;
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },
    //图片旋转
    picRotateRight() {
      this.picDeg += 90;
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },


    //判断选中的图片在什么位置
    beSurePic(i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * -80;
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },


    //清除放大缩小效果
    clearLargeAndSmall() {
    },

    picListClick(e, i) {
      this.clearLargeAndSmall();
      this.choosePicMsg = e
      this.getPicInfo(this.choosePicMsg)
      this.choosePicMsg.myId = i
      this.picAllListFlag = i;
      this.playerOptions.sources[0].src = this.choosePicMsg.src
    },

    //图片浏览中大的箭头 左边
    bigLeft() {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return;
      }

      this.clearLargeAndSmall();
      // if(this.choosePicMsg.id === this.picList.length - 1){
      //   return
      // }

      this.choosePicMsg = this.picList[this.choosePicMsg.myId - 1]
      this.playerOptions.sources[0].src = this.choosePicMsg.src
      this.getPicInfo(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0;
        this.picCha = -1;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览中大的箭头 右边
    bigRight() {
      if (this.choosePicMsg.myId === this.picList.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return;
      }
      this.clearLargeAndSmall();
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      this.choosePicMsg = this.picList[this.choosePicMsg.myId + 1]
      this.playerOptions.sources[0].src = this.choosePicMsg.src
      this.getPicInfo(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70;
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId;
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId;
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80;
          setTimeout(() => {
            this.picCha = this.scroll;
          }, 1000);
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览小的箭头 右边
    smallRight() {
      let picalllistwidth = this.$refs.picalllist.offsetWidth;
      let piclistwidth = this.$refs.piclist.offsetWidth;
      this.scroll = this.scroll - 300;
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70;
        this.picCha = this.scroll;
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform =
        "translateX(" + this.scroll + "px)";

      // console.log(this.scroll)
    },
    //图片浏览小的箭头 左边
    smallLeft() {
      // let picalllistwidth = this.$refs.picalllist.offsetWidth
      // let piclistwidth = this.$refs.piclist.offsetWidth
      this.scroll = this.scroll + 300;
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0;
      } else {
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }

      // console.log(this.scroll)
    },
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    },
    //获取图片信息
    getPicInfo(e) {
      e.createAtMy = formatConversion(e.createAt.toString()).substring(0, 10)
      if (e.exif && this.isJSON(e.exif)) {
        e.exif = JSON.parse(e.exif)
      }
      if (e.exif) {
        if (e.exif.CreateAt) {
          e.createAtMyTake = formatConversion(e.exif.CreateAt.toString()).substring(0, 10)
        } else {
          e.createAtMyTake = ''
        }

        if (e.exif.format) {
          e.format = e.exif.format
        } else {
          if (e.fileInfo.savepath) {
            e.format = e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3)
          } else {
            e.format = '暂无'
          }

        }

        

        if (e.fileInfo.fileSize) {
          e.fileSize = (e.fileInfo.fileSize / 1024 / 1024).toFixed(2) || '暂无'
        } else {
          e.fileSize = '暂无'
        }

      }
    },


  },
  created () {
    this.isRefresh = true


    //获取未整理图片
    this.listUnclutteredPictureAsync({
            page: this.currentPage,
            pageSize:this.pageSize,
            timeEnd:this.timeEnd,
            timeStart:this.timeStart
    })

    

    this.displayResolution = document.documentElement.clientWidth;

    this.documentHeight = document.documentElement.clientHeight

    if (this.documentHeight <= 650) {
      this.minRows = 0
      this.maxRows = 1
    } else if (this.documentHeight <= 775) {
      this.minRows = 4
      this.maxRows = 8
    } else if (this.documentHeight <= 970) {
      this.minRows = 8
      this.maxRows = 12
    }




  },
  mounted () {
    window.addEventListener("scroll", this.scrollPic);
    //获取侧边栏是否收起
    this.bus.$on('changeIsaside', (message) => {
      this.bus.val = message
      this.isAside = this.bus.val
      // this.isChildren = false
    })
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollPic);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./recycleVideo.scss";

/*滚动条样式*/
::v-deep ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
::v-deep ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}

.el-table ::v-deep .el-table__body tr td {
  cursor: pointer;
}
.el-table ::v-deep .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table ::v-deep .el-table__body .current-row td .cell {
  color: #fff !important;
}

// .el-radio-group ::v-deep .is-active .el-radio-button__inner {
//   background: #185ed3;
//   border-color: #185ed3;
// }
.seeInfo {
  background: #f2f2f2 !important;
  border: 1px solid rgba(119, 119, 119, 0.1);
  color: #333333;
  margin-right: -40px;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #3CB035;
  border-color: #3CB035;
}

::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog__body {
  display: flex;
  padding: 0;
}
</style>
